import { dataFetch } from '../../../api/data-fetch';
import { chunk } from '../../../utils/lib';
import api from '../../../api/endpoints';
import { sessionCache, sessionCached } from '../../../utils/cache';

const CACHE_TIME = 60 * 2; // seconds

// initial state
const state = () => ({
  selectionOdds: [],
});

const actions = {
  fetchEventOdds: async ({ commit }, eventIds = [], fetcher = dataFetch) => {
    commit('RESET');

    chunk(eventIds, 40).forEach(async eventIdGroup => {
      const params = { events: eventIdGroup.toString(), type: 'best', betTypes: 'fixed-win' };
      const cacheKey = 'BO/' + JSON.stringify(params);
      let response;

      if (!(response = sessionCached(cacheKey))) {
        response = await fetcher(api.ODDS.EVENTS, { params });
        sessionCache(cacheKey, response, CACHE_TIME);
      }
      commit('SET_ODDS', response.odds);
    });
  },
};

const getters = {
  getOdds: state => {
    return state.selectionOdds;
  },
  getSelectionOdds: (state, getters) => selectionId => {
    return getters['getOdds'].filter(odds => odds.selectionId === selectionId)[0];
  },
};

const mutations = {
  RESET: state => {
    state.selectionOdds = [];
  },
  SET_ODDS: (state, odds) => {
    state.selectionOdds = state.selectionOdds.concat(odds);
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
